import { NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { AuthService } from 'app/auth/auth.service';
import { BannerMessage, BannerService } from './banner.service';

@Component({
  selector: 'permanent-banner',
  imports: [NgClass],
  template: /*html*/ ` @if (message.Text) {
    <div class="banner permanent" [ngClass]="{ error: message.IsError }">
      {{ message.Text }}
      &nbsp;&nbsp;
      @if (showLogout) {
        <span class="link" (click)="logoutUser()">Logout</span>
      }
    </div>
  }`
})
export class PermanentBannerComponent {
  private bannerService = inject(BannerService);
  private authService = inject(AuthService);

  message: BannerMessage;
  showLogout: boolean;

  constructor() {
    // subscribe to banner service
    this.bannerService.permanentMessage.subscribe(bMess => {
      this.message = bMess;
      this.showLogout = this.authService.isImpersonating();
    });
  }

  logoutUser() {
    this.authService.logout();
  }
}
